import styled from 'styled-components'
import bgMobile from './join-mobile.png'
import joinBg from './join.svg'

const mobile = 'max-width: 1000px'

export const JoinSection = styled.div`
  padding: 90px 0;
  background-image: url(${joinBg});
  background-repeat: no-repeat;
  background-size: auto 100%;

  @media only screen and (${mobile}) {
    background-image: url(${bgMobile});
    background-size: cover;
  }
`

export const JoinColumn = styled.div`
  width: 810px;
  max-width: 65%;
  flex-shrink: 0;
  @media only screen and (${mobile}) {
    width: 100%;
    max-width: 400px;
  }
`

export const JoinTitle = styled.span`
  font-family: Helvetica Neue;
  font-size: 32px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0 80px 50px 0;
  display: block;

  & span {
    color: #ff5e6d;
  }

  @media only screen and (${mobile}) {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    margin: 0 0 60px;
  }
`
